/* eslint-disable max-len */
import React, { useEffect } from "react";

import { InfoIcon } from "../Icons";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { userActivityLogger } from "../../utils/mixpanel";

interface TotalCareRenewalBannerProps {
  onCTAClick: () => void;
}

const TotalCareRenewalBanner = ({ onCTAClick }: TotalCareRenewalBannerProps) => {
  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.MOVE_YOUR_PLAN_TO_TOTALCARE_BANNER_SHOWN, {
      bannerName: "Renew Your TotalCare Plan",
    });
  }, []);

  return (
    <div
      className="flex gap-2 items-center p-2 rounded-lg border bg-gv-yellow-light border-gv-gold-1 w-full"
    >
      <div className="shrink-0">
        <InfoIcon width={24} height={24} color="#262626" />
      </div>
      <div className="grow flex flex-col justify-center min-h-px min-w-px">
        <p className="text-sm leading-5 font-normal">
          Renew Your TotalCare Plan
        </p>
      </div>
      <button
        onClick={onCTAClick}
        className="shrink-0 text-sm leading-[14px] font-medium underline text-right cursor-pointer bg-transparent border-none"
      >
        Review Options
      </button>
    </div>
  );
};

export default TotalCareRenewalBanner;

